import React from 'react';
import {
  LocacoesTableScroll,
  LocacoesTableEl,
  LocacoesLoadingOverlay,
  LocacoesSpinner,
  LocacoesEmptyRow,
  LocacoesEmptyCell
} from './requestsLocacoesTable.styles';

const LocacoesTableView = ({ loading, lines, renderHeader, renderLine }) => {
  const hasRows = Array.isArray(lines) && lines.length > 0;

  return (
    <LocacoesTableScroll>
      {loading && (
        <LocacoesLoadingOverlay aria-busy="true" aria-live="polite">
          <LocacoesSpinner />
        </LocacoesLoadingOverlay>
      )}
      <LocacoesTableEl>
        <thead>{renderHeader()}</thead>
        <tbody>
          {hasRows
            ? lines.map((line, index) => renderLine(line, index))
            : !loading && (
                <LocacoesEmptyRow>
                  <LocacoesEmptyCell colSpan={5}>
                    Nenhuma locação encontrada.
                  </LocacoesEmptyCell>
                </LocacoesEmptyRow>
              )}
        </tbody>
      </LocacoesTableEl>
    </LocacoesTableScroll>
  );
};

export default LocacoesTableView;
